import React, { FC } from 'react'
import styles from './TableRow.module.scss'

type TableRowProps = React.TableHTMLAttributes<HTMLTableRowElement>

export const TableRow: FC<TableRowProps> = ({ children, ...props }) => {
  return (
    <tr {...props} className={styles.tableRow}>
      {children}
    </tr>
  )
}

TableRow.displayName = 'TableRow'
